import { redirect } from 'react-router-dom';

import run from './schema';

const API_ROLES = ['admin', 'operator', 'collector', 'assist', 'user'];

export const generate = (data: { mobile: string }) => {
  return run({
    url: 'auth/generate',
    data: data,
    method: 'Post',
  });
};

export const loginOtp = (data: { mobile: string; code: string }) => {
  return run({
    url: 'auth/login_otp',
    data: data,
    method: 'Post',
  });
};

export const directLogin = (data: { username: string; password: string }) => {
  return run({
    url: 'auth/login',
    data: data,
    method: 'Post',
  });
};

//setting
export const getSetting = () => {
  return run({
    url: 'public/settings',
    method: 'GET',
  });
};


// loader
export const verifyUserToken = (token: string) => {
  const output = { status: 'error', message: 'Unauthenticated' };

  const request = run({
    url: 'auth/verify',
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then((res) => {
      if (res.status === 200) {
        return { ...output, status: 'ok', data: res.data, message: null };
      } else {
        return output;
      }
    })
    .catch((error) => {
      return output;
    });

  return request;
};

export const logout = async () => {
  const accessToken = localStorage.getItem('accessToken');

  if (accessToken === null) {
    return cleanAndRedirect(true);
  }

  const convertedAccessToken: any = JSON.parse(accessToken);

  if (
    convertedAccessToken?.access_token &&
    convertedAccessToken?.expires_in_unix &&
    isExpired(convertedAccessToken?.expires_in_unix)
  ) {
    try {
      await run({
        url: 'auth/logout',
        method: 'Post',
        headers: {
          Authorization: `Bearer ${convertedAccessToken?.access_token}`,
        },
      });
      return cleanAndRedirect(true);
    } catch (error) {
      return cleanAndRedirect(true);
    }
  } else {
    return cleanAndRedirect(true);
  }
};

export const loginLoader = async (
  role: 'admin' | 'operator' | 'collector' | 'assist' | 'user' | null = null
) => {
  const accessToken = localStorage.getItem('accessToken');

  if (accessToken === null) {
    if (role === null) {
      return {};
    }
    return cleanAndRedirect();
  }

  const convertedAccessToken: any = JSON.parse(accessToken);

  if (
    convertedAccessToken?.access_token &&
    convertedAccessToken?.expires_in_unix &&
    isExpired(convertedAccessToken?.expires_in_unix)
  ) {
    const verify: any = await verifyUserToken(
      convertedAccessToken.access_token
    );

    if (verify.status === 'ok' && !API_ROLES.includes(verify?.data?.role))
      return cleanAndRedirect();

    if (verify.status === 'ok' && (role === null || role !== verify.data.role))
      return redirect(`/${verify.data.role}/dashboard`);

    if (verify.status === 'ok' && role === verify.data.role) {
      localStorage.setItem(
        'accessToken',
        JSON.stringify({
          ...convertedAccessToken,
          role: verify.data.role,
          setting: {
            favicon: verify?.data?.setting?.favicon,
            updated_at: verify?.data?.setting?.updated_at,
            logo: verify?.data?.setting?.logo,
          },
        })
      );
      return { role: verify.data.role };
    }
  }
  return cleanAndRedirect();
};

export const isExpired = (timestamp: number | undefined | null) => {
  if (typeof timestamp !== 'number') return false;
  const currentTimestampMilliseconds = +new Date(); // Current timestamp in milliseconds
  const currentTimestampSeconds = Math.floor(
    currentTimestampMilliseconds / 1000
  );

  return currentTimestampSeconds < timestamp;
};

export const cleanAndRedirect = (locationRedirect: boolean = false) => {
  localStorage.removeItem('accessToken');
  if (!locationRedirect) return redirect('/login');

  window.location.replace('/login');
  return;
};
